export const SET_SITE_LOADING = "SET_SITE_LOADING";

export const SET_CATEGORIES = "SET_CATEGORIES";
export const SET_CURRENT_CATEGORY = "SET_CURRENT_CATEGORY";
export const SET_MENU_STATUS = "SET_MENU_STATUS";
export const ADD_TO_BUCKET = "ADD_TO_BUCKET";
export const REMOVE_FROM_BUCKET = "REMOVE_FROM_BUCKET";
export const SET_CATEGORY_PRODUCTS = "SET_CATEGORY_PRODUCTS";
export const SET_CURRENT_PAGE = "SET_CURRENT_PAGE";
export const SET_POPUP = "SET_POPUP";
export const SET_USER = "SET_USER";
export const SHOW_MESSAGE = "SHOW_MESSAGE";
export const SET_CATEGORY_MENU_STATUS = "SET_CATEGORY_MENU_STATUS";
export const SET_OPTIONS = "SET_OPTIONS";